import { z } from "zod";
import {
  SerialKillerListItemDTOz,
  type SerialKillerListItemDTO,
  SerialKillerDTOz,
  type SerialKillerDTO,
} from "@shared/contracts";
import { get, qs } from "./client";

const SerialKillerListItemCompatZ = z
  .object({
    id: z.string(),
    name: z.string(),
    alias: z.string().nullable(),
    status: z.string().nullable().optional(),
    numberOfVictims: z.number().int().nonnegative().nullable().optional(),
    activeYearStart: z.number().int().nonnegative().nullable().optional(),
    activeYearEnd: z.number().int().nonnegative().nullable().optional(),
  })
  .transform((item): SerialKillerListItemDTO =>
    SerialKillerListItemDTOz.parse({
      id: item.id,
      name: item.name,
      alias: item.alias,
      status: item.status ?? null,
      numberOfVictims: item.numberOfVictims ?? null,
      activeYearStart: item.activeYearStart ?? null,
      activeYearEnd: item.activeYearEnd ?? null,
    })
  );

const SerialKillerListZ = z.array(SerialKillerListItemCompatZ);

export async function fetchSerialKillers(signal?: AbortSignal): Promise<SerialKillerListItemDTO[]> {
  return get("/serialkillers/getSerialKillers", (raw) => SerialKillerListZ.parse(raw), { signal });
}

export async function fetchSerialKillerById(
  killerId: string,
  signal?: AbortSignal
): Promise<SerialKillerDTO> {
  return get(
    `/serialkillers/getSerialKillerById${qs({ id: killerId })}`,
    (raw) => SerialKillerDTOz.parse(raw),
    { signal }
  );
}